import { render } from "./VacunaMarc_VacunaProd.vue?vue&type=template&id=bb7fd930"
import script from "./VacunaMarc_VacunaProd.vue?vue&type=script&lang=js"
export * from "./VacunaMarc_VacunaProd.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__